module.exports = __webpack_public_path__ + "img/angled-lines.9c2dcc6a.svg";